/* eslint-disable no-lone-blocks */
import React from 'react'
import PropTypes from 'prop-types'

import Path from './paths'

const SVGIcon = props => {
	return (
		<svg
			width='30'
			height='30'
			viewBox='0 0 30 30'
			fill='none'
			focusable='false'
			data-test-id={`${props.id}-icon-svg`}
			xmlns='http://www.w3.org/2000/svg'
			{...props.svgProps}
		>
			<Path iconName={props.iconName} id={`${props.id}-data-id`} {...props} />
		</svg>
	)
}
SVGIcon.propTypes = {
	iconName: PropTypes.string,
	id: PropTypes.string,
}

export default SVGIcon
